import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { AuthService } from '../../auth/auth.service';

const endpoint = environment.apiBaseUrl + '/admin/tipos/validaciones/v1';

const httpOptions = {
    headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/octet-stream'
    }),
};

@Injectable({
    providedIn: "root",
})
export class TiposValidacionesService {

    constructor(private httpClient: HttpClient, private authService: AuthService) {

    }

    private extractData(res: Response) {
        const body = res;
        return body || {};
    }

    //HTTP
    //Cargar el árbol y las preguntas frecuentes con sus ids.
    loadTiposValidaciones(habilitado) {
        return this.httpClient.get<any>(endpoint + `/list?habilitado=${habilitado}`).pipe(map(this.extractData));  
    }
}
